<app-header></app-header>
<div class="container-fluid">
    <ngx-spinner type="ball-beat"></ngx-spinner>
    <div class="row mt-2">
        <div class="col-lg-12">
            <div class="card card-primary">
                <div class="card-header">
                    <span class="headText1">ระบบฝากหักค่าอ้อย ({{supcode}} - {{supname}}) <b style="color: crimson;"
                            *ngIf="!canEdit"> ต้องใช้รหัสของธุรการโซนเท่านั้นถึงจะแก้ไขข้อมูลได้ </b>
                    </span>
                </div>

                <div *ngIf="!canDeposit" class="alert alert-danger mx-2 my-2">
                    <button type="button" class="close" data-dismiss="alert" aria-hidden="true">&times;</button>
                    <h1><i class="icon fas fa-ban"></i> Alert!</h1>
                    ขณะนี้ อยู่ระหว่างประมวลผลค่าอ้อย ไม่สามารถทำรายการฝากหักได้
                </div>
                <div *ngIf="canDeposit">
                    <div class="card-header">
                        <form #frm_scpc="ngForm" class="gx-3 gy-2 row align-items-center">
                            <div class="col-sm-auto">
                                <!--
                                <mat-form-field appearance="fill">
                                    <mat-label>1.เลือกเงื่อนไข</mat-label>
                                    <select matNativeControl #scontent="ngModel" ngModel name="scontent" id="scontent"
                                        class="form-control" [(ngModel)]="selectedOption" (change)="getLabel()" required
                                        [ngClass]="{'is-invalid' : scontent.invalid && (xsearch.dirty || xsearch.touched)}">
                                        <option value="">++เลือกเงื่อนไข++</option>
                                        <option value="1">ตามกลุ่มรถตัด </option>
                                        <option value="6">ตามเบอร์รถคีบ </option>
                                        <option value="4">ตามกลุ่มตัดอ้อย </option>
                                        <option value="2">ตามเลขบัญชีเจ้าของรถบรรทุก</option>
                                        <option value="3">ตามเลขบัญชีเจ้าของอ้อย</option>
                                        <option value="5">ตามทะเบียนรถบรรทุกอ้อย</option>
                                    </select>
                                    <mat-error *ngIf="scontent.hasError('required')">*ต้องเลือกเงื่อนไข</mat-error>
                                </mat-form-field>
                                -->
                                <label class="visually-hidden" for="scontent">1.เลือกเงื่อนไข</label>
                                <select #scontent="ngModel" ngModel name="scontent" id="scontent" class="form-control"
                                    [(ngModel)]="selectedOption" (change)="getLabel()" required
                                    [ngClass]="{'is-invalid' : scontent.invalid && (scontent.dirty || scontent.touched)}">
                                    <option value="" disabled selected>++เลือกเงื่อนไข++</option>
                                    <option value="1">ตามรหัสรถตัด </option>
                                    <option value="6">ตามเบอร์รถคีบ </option>
                                    <option value="4">ตามกลุ่มตัดอ้อย </option>
                                    <option value="2">ตามเลขบัญชีเจ้าของรถบรรทุก</option>
                                    <option value="3">ตามเลขบัญชีเจ้าของอ้อย</option>
                                    <option value="5">ตามทะเบียนรถบรรทุกอ้อย</option>
                                </select>
                                <div class="invalid-feedback">
                                    <span *ngIf="scontent.hasError('required')">*ต้องเลือกเงื่อนไข</span>
                                </div>
                            </div>
                            <div class="col-sm-auto">
                                <!--
                                <mat-form-field class="example-full-width" appearance="fill">
                                    <mat-label>2.<span id="showlabel" class="text-primary">
                                            {{showLabel}}</span></mat-label>
                                    <input #xsearch="ngModel" ngModel name="xsearch" id="xsearch" type="text"
                                        class="form-control" placeholder="ตามเงื่อนไข" required
                                        [ngClass]="{'is-invalid' : xsearch.invalid && (xsearch.dirty || xsearch.touched)}">
                                    <mat-error *ngIf="xsearch.hasError('required')">
                                        *ต้องป้อนสิ่งที่เลือก
                                    </mat-error>
                                </mat-form-field>
                                -->
                                <label class="visually-hidden" for="xsearch">2.<span id="showlabel"
                                        class="text-primary">{{ showLabel }}</span></label>
                                <div class="input-group">
                                    <input #xsearch="ngModel" ngModel name="xsearch" id="xsearch" type="text"
                                        class="form-control" placeholder="ตามเงื่อนไข" required
                                        [ngClass]="{'is-invalid' : xsearch.invalid && (xsearch.dirty || xsearch.touched)}">
                                    <div class="invalid-feedback">
                                        <span *ngIf="xsearch.hasError('required')">*ต้องป้อนสิ่งที่เลือก</span>
                                    </div>
                                </div>

                            </div>
                            <div class="col-sm-auto">
                                <!--<mat-form-field appearance="fill">
                                    <mat-label>3.จากวันที่</mat-label>
                                    <mat-date-range-input [rangePicker]="picker">
                                        <input matStartDate #datefrom="ngModel" ngModel name="datefrom" type="date"
                                            id="datefrom" required
                                            [ngClass]="{'is-invalid' : datefrom.invalid && (datefrom.dirty || datefrom.touched)}">
                                        <input matEndDate #dateto="ngModel" ngModel name="dateto" type="date"
                                            id="dateto" required
                                            [ngClass]="{'is-invalid' : dateto.invalid && (dateto.dirty || dateto.touched)}">
                                    </mat-date-range-input>
                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                    <mat-date-range-picker #picker></mat-date-range-picker>

                                    <mat-error
                                        *ngIf="datefrom.hasError('required')">*ต้องเลือกวันที่เริ่มต้น</mat-error>
                                    <mat-error *ngIf="dateto.hasError('required')">*ต้องเลือกวันที่สิ้นสุด</mat-error>
                                </mat-form-field>
                            -->
                                <label class="visually-hidden" for="datefrom">3.จากวันที่</label>
                                <input #datefrom="ngModel" ngModel name="datefrom" type="date" id="datefrom"
                                    class="form-control" required
                                    [ngClass]="{'is-invalid' : datefrom.invalid && (datefrom.dirty || datefrom.touched)}">
                                <div class="invalid-feedback">
                                    <span *ngIf="datefrom.hasError('required')">*ต้องเลือกวันที่เริ่มต้น</span>
                                </div>
                            </div>
                            <div class="col-sm-auto">
                                <label class="visually-hidden" for="dateto">4.ถึงวันที่</label>
                                <input #dateto="ngModel" ngModel name="dateto" type="date" id="dateto"
                                    class="form-control" required
                                    [ngClass]="{'is-invalid' : dateto.invalid && (dateto.dirty || dateto.touched)}">
                                <div class="invalid-feedback">
                                    <span *ngIf="dateto.hasError('required')">*ต้องเลือกวันที่สิ้นสุด</span>
                                </div>

                            </div>
                            <div class="col-sm-auto">
                                <!-- <label class="visually-hidden" for="btn_submit">5.Submit</label> -->
                                <button type="submit" class="btn btn-primary btn-block" [disabled]="frm_scpc.invalid"
                                    (click)="getCpcData(frm_scpc.value);">ค้นหา</button>
                            </div>
                            <div class="col-sm-auto" *ngIf="cpcData.length > 0">
                                <button class="btn btn-outline-success btn-sm" (click)="ExportExcel()">
                                    <i class="far fa-file-excel"></i>&nbsp;
                                    <span class="badge bg-secondary">{{ cpcData.length}}</span> รายการ
                                </button>
                            </div>&nbsp;
                            <div class="col-sm-auto" *ngIf="cpcData.length > 0">
                                <div class="button-row">
                                    <button mat-raised-button *ngIf="edit_st == 0" (click)="edit_st = 1"
                                        [disabled]="!canDeposit || !canEdit">
                                        <mat-icon style="color: blue;">edit</mat-icon> แก้ไขข้อมูล
                                    </button>
                                    <button mat-raised-button *ngIf="edit_st != 0" (click)="saveData()">
                                        <mat-icon style="color: green;"> done </mat-icon>บันทึก
                                    </button>
                                    <button mat-raised-button *ngIf="edit_st != 0" (click)="edit_st = 0">
                                        <mat-icon style="color: red;"> close </mat-icon>ยกเลิก
                                    </button>
                                </div>
                            </div>
                            <div class="col-sm-auto" *ngIf="cpcData.length > 0">
                                <mat-form-field class="example-full-width" style="text-align:center">
                                    <input matInput [(ngModel)]="text_f" [ngModelOptions]="{standalone: true}"
                                        placeholder="คำค้นหา" style="text-align:center">
                                    <button *ngIf="text_f" matSuffix mat-icon-button aria-label="Clear"
                                        (click)="text_f=''">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </form>
                    </div>

                    <div class="card-body table-responsive p-2" style="align-items: center;height: 650px">
                        <table #table
                            class="table table-head-fixed text-nowrap table-hover table-striped table-bordered">
                            <thead>
                                <tr class="headText text-primary" style="text-align:center">
                                    <th class="table-primary" scope="col">.</th>
                                    <th class="table-primary" scope="col">วันที่</th>
                                    <th class="table-primary" scope="col">เลขใบชั่ง</th>
                                    <th class="table-primary" scope="col">เจ้าของอ้อย</th>
                                    <th class="table-primary" scope="col">กลุ่มตัด</th>
                                    <th class="table-primary" scope="col">น้ำหนัก</th>
                                    <th class="table-primary" scope="col">CCS</th>
                                    <th class="table-primary" scope="col">อ้อยสด/ไฟ</th>
                                    <th class="table-success" scope="col">รหัสรถ</th>
                                    <th class="table-success" scope="col">รถบรรทุก</th>
                                    <th class="table-success" scope="col">เจ้าของรถบรรทุก</th>
                                    <th class="table-success" scope="col">ค่าบรรทุก</th>
                                    <th class="table-danger" scope="col">รหัสรถตัด</th>
                                    <th class="table-danger" scope="col">เจ้าของรถตัด</th>
                                    <th class="table-danger" scope="col">ค่าตัด</th>
                                    <th class="table-info" scope="col">เบอร์รถคีบ</th>
                                    <th class="table-info" scope="col">เจ้าของรถคีบ</th>
                                    <th class="table-info" scope="col">ค่าคีบ</th>
                                </tr>
                            </thead>
                            <tbody [ngSwitch]="edit_st">
                                <tr *ngFor="let item of cpcData | filter:text_f; let i = index;" class="textTable"
                                    [ngClass]="{'table-Light under':item.Status_cal=='N' ,'thead-light':(item.Status_cal=='Y' )}">
                                    <td style="text-align:center">{{i+1}}
                                        <i class='far fa-edit' *ngIf="item.modify" style='font-size:14px;color:red'></i>
                                    </td>
                                    <td>{{ item.REPORTDATE | date }}</td>
                                    <td>{{ item.TRUCK_Q }}</td>
                                    <td><span class="badge badge-secondary" style='font-size:12px;'>
                                            {{item.FMCODE}}</span>:{{ item.fmname }}</td>
                                    <td style="text-align:center">{{ item.groupcodeQ }}</td>
                                    <td style="text-align:center">{{ item.WGT_NET | number:'1.2-2' }}</td>
                                    <td style="text-align:center">{{ item.CCS_VALUE | number:'1.2-2' }}</td>
                                    <td style="text-align:center">{{ item.canename }}</td>
                                    <td>
                                        <input *ngSwitchCase="1" type="text" matInput
                                            [ngStyle]="{'background-color': (item.ck_truck) ? '#cfc6c6' : '#fffbe3' }"
                                            [disabled]="item.ck_truck || item.Status_cal=='Y'"
                                            style="text-align:center; width: 100px;" [ngModel]="item.truck_no"
                                            (ngModelChange)="item.truck_no = $event; item.modify = true;" />
                                        <div style="text-align:center" *ngSwitchCase="0">{{ item.truck_no }}
                                        </div>
                                    </td>
                                    <td>
                                        <input *ngSwitchCase="1" type="text" matInput
                                            [ngStyle]="{'background-color': (item.ck_truck) ? '#cfc6c6' : '#fffbe3' }"
                                            [disabled]="item.ck_truck || item.Status_cal=='Y'"
                                            style="text-align:center;width: 90px;" [ngModel]="item.regtruck"
                                            (ngModelChange)="item.regtruck = $event; item.modify = true;" />
                                        <div style="text-align:center" *ngSwitchCase="0">{{ item.regtruck }}
                                        </div>
                                    </td>
                                    <td>
                                        <input *ngSwitchCase="1" type="text" matInput
                                            [ngStyle]="{'background-color': (item.ck_truck) ? '#cfc6c6' : '#fffbe3' }"
                                            [disabled]="item.ck_truck || item.Status_cal=='Y'"
                                            style="text-align:center;width: 80px;" [ngModel]="item.OWNCODE"
                                            (ngModelChange)="item.OWNCODE = $event; item.modify = true;" />
                                        <div style="text-align:left" *ngSwitchCase="0">
                                            <span class="badge badge-warning" style='font-size:12px;'>{{
                                                item.OWNCODE }}</span>
                                            :{{item.fmnameowntruck }}
                                        </div>
                                    </td>
                                    <td>
                                        <input *ngSwitchCase="1" type="number" min="0" matInput
                                            [ngStyle]="{'background-color': (item.ck_truck) ? '#cfc6c6' : '#fffbe3' }"
                                            [disabled]="item.ck_truck || item.Status_cal=='Y'"
                                            style="text-align:center;width: 60px;" [ngModel]="item.TRUCK_FEE"
                                            (ngModelChange)="item.TRUCK_FEE = $event; item.modify = true;" />
                                        <div style="text-align:center" *ngSwitchCase="0">{{ item.TRUCK_FEE }}
                                        </div>

                                    </td>
                                    <td>
                                        <input *ngSwitchCase="1" type="text" matInput
                                            [ngStyle]="{'background-color': (item.ck_cut) ? '#cfc6c6' : '#e0fcd7' }"
                                            [disabled]="item.ck_cut || item.Status_cal=='Y'"
                                            style="text-align:center; width: 80px;" [ngModel]="item.CUT_NO"
                                            (ngModelChange)="item.CUT_NO = $event; item.modify = true;" />
                                        <div style="text-align:center" *ngSwitchCase="0">{{ item.CUT_NO }}</div>
                                    <td>
                                        <input *ngSwitchCase="1" type="text" matInput
                                            [ngStyle]="{'background-color': (item.ck_cut) ? '#cfc6c6' : '#e0fcd7' }"
                                            [disabled]="item.ck_cut || item.Status_cal=='Y'"
                                            style="text-align:center; width: 80px;" [ngModel]="item.OWNCODE_CUT"
                                            (ngModelChange)="item.OWNCODE_CUT = $event; item.modify = true;" />
                                        <div style="text-align:left" *ngSwitchCase="0">
                                            <span class="badge badge-success" style='font-size:12px;'>{{
                                                item.OWNCODE_CUT}}</span>
                                            :{{ item.fmnameowncut }}
                                        </div>
                                    </td>
                                    <td>
                                        <input *ngSwitchCase="1" type="number" min="0" matInput
                                            [ngStyle]="{'background-color': (item.ck_cut) ? '#cfc6c6' : '#e0fcd7' }"
                                            [disabled]="item.ck_cut || item.Status_cal=='Y'"
                                            style="text-align:center; width: 60px;" [ngModel]="item.CUT_RATE"
                                            (ngModelChange)="item.CUT_RATE = $event; item.modify = true;" />
                                        <div style="text-align:center" *ngSwitchCase="0">{{ item.CUT_RATE }}
                                        </div>
                                    </td>

                                    <td>
                                        <input *ngSwitchCase="1" type="text" matInput
                                            [ngStyle]="{'background-color': (item.ck_keep) ? '#cfc6c6' : '#d0ecf7' }"
                                            [disabled]="item.ck_keep || item.Status_cal=='Y'"
                                            style="text-align:center; width: 100px;" [ngModel]="item.keep_no"
                                            (ngModelChange)="item.keep_no = $event; item.modify = true;" />
                                        <div style="text-align:center" *ngSwitchCase="0">{{ item.keep_no }}
                                        </div>
                                    </td>
                                    <td>
                                        <input *ngSwitchCase="1" type="text" matInput
                                            [ngStyle]="{'background-color': (item.ck_keep) ? '#cfc6c6' : '#d0ecf7' }"
                                            [disabled]="item.ck_keep || item.Status_cal=='Y'"
                                            style="text-align:center; width: 80px;" [ngModel]="item.OWNCODE_KEEP"
                                            (ngModelChange)="item.OWNCODE_KEEP = $event; item.modify = true;" />
                                        <div style="text-align:left" *ngSwitchCase="0">
                                            <span class="badge badge-info" style='font-size:12px;'>{{
                                                item.OWNCODE_KEEP }}</span>
                                            :{{ item.fmnameownkeep }}
                                        </div>
                                    </td>
                                    <td>
                                        <input *ngSwitchCase="1" type="number" min="0" matInput
                                            [ngStyle]="{'background-color': (item.ck_keep) ? '#cfc6c6' : '#d0ecf7' }"
                                            [disabled]="item.ck_keep || item.Status_cal=='Y'"
                                            style="text-align:center; width: 60px;" [ngModel]="item.KEEP_RATE"
                                            (ngModelChange)="item.KEEP_RATE = $event; item.modify = true;" />
                                        <div style="text-align:center" *ngSwitchCase="0">{{ item.KEEP_RATE }}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>